import React, { useEffect, useState } from "react";
import { Button } from "../Button/Button";
import { HeroInternas } from "../heroInternas/HeroInternas";
import axios from "axios";

export const GastosDeEntrega = () => {
    const [gastosEntrega, setGastosEntrega] = useState(null); // Global parameter data
    const [documentosGastos, setDocumentosGastos] = useState([]); // Documentos Gastos

    useEffect(() => {
        // Fetch global parameters and documentos gastos
        const fetchData = async () => {
            try {
                const response = await fetch("/get_gastos_entrega_data");
                const result = await response.json();

                // Set the state with the response data
                setGastosEntrega({
                    description: result.titulo,
                    value: result.texto,
                });
                setDocumentosGastos(result.documentos_gastos || []);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    const handleDownload = async (id, title) => {
        try {
            const response = await axios.get(`api/descargar_documentacion_gastos/${id}`, {
                responseType: "blob", // Ensure the response is treated as binary data
            });

            // Create a URL for the blob and trigger a download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", title); // Set the downloaded file name
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };

    return (
        <>
            <div>
                <div className="gastosDeEntrega">
                    <div className="gastosDeEntrega--container">
                        {/* Display GastosEntrega data */}
                        {gastosEntrega ? (
                            <div className="gastosDeEntrega--div">
                                <h1>Gastos de Entrega</h1>
                                <div>
                                    <h2 className="gastosDeEntrega--h2">{gastosEntrega.description}</h2>
                                    <div dangerouslySetInnerHTML={{ __html: gastosEntrega.value }} />
                                </div>
                            </div>
                        ) : (
                            <div className="d-flex justify-content-center">
                                <div
                                    className="spinner-border text-amarillo mb-half"
                                    role="status"
                                >
                                </div>
                            </div>
                        )}

                        <div className="separator--hor my-half mb-octa"></div>

                        {/* Display DocumentosGastos buttons */}
                        <div className="gastosDeEntrega--div">
                            <h1>Documentos</h1>
                            <div className="gastosDeEntrega--div--innerDiv">
                                {documentosGastos.length > 0 ? (
                                    documentosGastos
                                        .filter((doc) => doc.is_enabled) // Filter out documents where is_enabled is false
                                        .map((doc) => (
                                            <Button
                                                key={doc.id}
                                                className="btn-info-general"
                                                pdf={`/api/descargar_documentacion_gastos/${doc.id}`}
                                                text={doc.title}
                                            />
                                        ))
                                ) : (
                                    <p>No hay documentos disponibles.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
